import classnames from 'classnames';
import type { FC, HTMLAttributes } from 'react';

import styles from './tbody.module.scss';

export type TBodyProps = HTMLAttributes<HTMLTableSectionElement> & {
  className?: string;
  isLoading?: boolean;
};

export const TBody: FC<TBodyProps> = ({ className, children, isLoading = false, ...props }) => (
  <tbody className={classnames(styles.root, className)} {...props}>
    {!isLoading && children}
  </tbody>
);
